<template>
  <div class="cf-flex cf-flex--column cf-flex--gap-16 cf-flex--align-center cf-padding-bottom-16">
    <span
      v-if="data.iconClass"
      :class="['cf-icon cf-icon--brand-primary cf-icon--large far', data.iconClass]"
    />

    <img
      v-if="data.imageUrl"
      class="cf-image cf-image--logo"
      :src="data.imageUrl"
      onerror="this.src='/images/image-not-found.png';"
    >

    <h2
      v-if="data.title"
      class="cf-title cf-title--2"
    >
      {{ data.title }}
    </h2>

    <p
      class="cf-subtitle cf-subtitle--2"
      v-html="data.description"
    />

    <button
      class="cf-button cf-button--primary cf-button--lg cf-button--fill"
      type="button"
      @click="closeModalHandler"
    >
      {{ data.ctaConfirmText || 'Continue' }}
    </button>
  </div>
</template>


<script>
  export default {
    name: 'CfNotice',

    props: {
      data: {
        type: Object,
        required: true
      }
    },

    methods: {
      closeModalHandler() {
        this.$closeModal('notice-modal');
      }
    }
  };
</script>
